import { __assign } from "tslib";
import { createWhatsappApi } from '.';
import { createFakePostResponder, createFakeGetResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
export var createWhatsappApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createWhatsappApi('', fakeHttp);
    var whatsappRelativePath = '/whatsapp';
    var settingsWhatsappRelativePath = '/settings/whatsapp';
    var TestKit = {
        whenAddAgentReply: function (dto) { return createFakePostResponder(fakeHttp, whatsappRelativePath + "/message")(dto); },
        whenGetTemplates: function (dto) { return createFakeGetResponder(fakeHttp, settingsWhatsappRelativePath + "/templates?locale=" + dto.locale); }
    };
    return __assign(__assign({}, api), TestKit);
};
//# sourceMappingURL=testkit.js.map